import React, { Component } from 'react';

class Bold5DecimalTextFormatter extends Component {
  render() {
    const { value } = this.props;
    return <span style={{ 'font-weight': 'bold' }}>{(value && parseFloat(value).toFixed(5)) || '-'}</span>;
  }
}

export default Bold5DecimalTextFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/bold5DecimalTextFormatter.jsx